export const emtaRoutes = {
  'api.emta.validate': 'users/validate-emta',
};
